var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_25_4943"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_25_4943)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 4.75,
    width: 16.5,
    height: 14.5,
    rx: 1.25,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#192038",
    fill: "none",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.9819,11.964501L19.4964,16.05574L20.5036,14.94426L15.5381,10.44426Q15.4906,10.401234,15.4366,10.366885Q15.3825,10.332535,15.3233,10.307858Q15.2642,10.283181,15.2018,10.268891Q15.1393,10.254601,15.0753,10.251113Q15.0113,10.247624,14.9477,10.255038Q14.8841,10.262452,14.8226,10.280553Q14.7611,10.298655,14.7036,10.326919Q14.6461,10.355184,14.5943,10.392792L3.559774,18.392789999999998L4.440226,19.607210000000002L14.9819,11.964501Z",
    fillRule: "evenodd",
    fill: "#192038",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 9.5,
    rx: 1.5,
    ry: 1.5,
    fillOpacity: 0,
    strokeOpacity: 1,
    stroke: "#192038",
    fill: "none",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImg);
export default __webpack_public_path__ + "static/media/icon_img.af9bb8da00417c5fc0ae25cbedb81291.svg";
export { ForwardRef as ReactComponent };